import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgDay = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill='#008AA0'
      fillRule='evenodd'
      d='M12.282 15.194c1.935 1.784 4.493 3.78 7.19 3.793h.047a4.38 4.38 0 0 0 2.678-.933q.273-.215.514-.469a4.73 4.73 0 0 0 1.208-2.388 4.84 4.84 0 0 0-.266-2.683 4.64 4.64 0 0 0-1.65-2.084 4.4 4.4 0 0 0-2.484-.788h-.928v3.597c.502.018.976.238 1.325.613.348.375.543.876.543 1.397 0 .52-.195 1.022-.543 1.396a1.9 1.9 0 0 1-1.325.614h-.027c-.118 0-.245 0-.353-.018-1.596-.316-3.513-2.021-4.797-3.166l-.037-.033z'
      clipRule='evenodd'
    />
    <path
      fill='#008AA0'
      fillRule='evenodd'
      d='M1.969 12.808a2.95 2.95 0 0 1 1.07-1.126c.447-.269.956-.408 1.473-.404 1.62 0 3.209.888 4.485 1.851l.85-1.274-.322-.227c-.061-.044-.118-.074-.16-.105l-.066-.048a12.5 12.5 0 0 0-1.399-.887 7.2 7.2 0 0 0-3.4-.933 4.42 4.42 0 0 0-3.182 1.368A4.76 4.76 0 0 0 0 14.327c0 1.24.474 2.428 1.318 3.304A4.42 4.42 0 0 0 4.5 19a6.2 6.2 0 0 0 3.13-.933c.245-.143.49-.3.722-.47.321-.226.635-.476.947-.738 1.927-1.637 3.484-3.676 5.386-5.336q.577-.508 1.21-.935a4.9 4.9 0 0 1 2.701-.933V6.002h-.032a6.68 6.68 0 0 0-4.767 1.866 9.5 9.5 0 0 0-.901.974c-.209.254-.408.527-.597.805-1.839 2.664-4.009 7.617-7.826 7.617-.5.013-.993-.11-1.433-.355a2.9 2.9 0 0 1-1.074-1.047 3.13 3.13 0 0 1-.394-1.527c0-.537.137-1.063.397-1.527'
      clipRule='evenodd'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgDay)
export default ForwardRef
